<details-section [title]="'simulationBuilder.ASSIGNMENT_INFORMATION_TITLE' | transloco" [attr.title]="null" [showDetails]="false">
  <assignment-information-view
    [form]="form"
    [assignmentTypeOptions]="assignmentTypeOptions"
    [callUuid]="callUuid"
    [isNewAssignment]="isNewAssignment"
    (valueChange)="onFormValueChange($event)"
  ></assignment-information-view>
</details-section>
